export default "__VITE_ASSET__53ZCtS$E__"